import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Polygon,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Polygon, { points: "13 19 22 12 13 5 13 19", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polygon, { points: "2 19 11 12 2 5 2 19", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "FastForward";
const FastForward = memo(themed(Icon));
export {
  FastForward
};
//# sourceMappingURL=fast-forward.js.map
